import { catalogLanguagePath } from '../helpers/catalog';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  RadioGroup,
  Stack,
  Radio,
  ModalFooter,
  Button,
  Box,
  useColorModeValue
} from '@chakra-ui/react';
import * as React from 'react';
import { useTranslationsContext } from './useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  locale: string;
  catalogLocales?: string[];
};

export const SelectLanguageModal: React.FC<Props> = ({ isOpen, onClose, locale, catalogLocales }) => {
  const { select_language, confirm } = useTranslationsContext();
  const [defaultLocale, setDefaultLocale] = React.useState(locale);
  const modalBg = useColorModeValue('white', 'gray.800');
  const modalTextColor = useColorModeValue('black', 'white');
  const radioBg = useColorModeValue('red.50', 'red.800');

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor={modalBg} textColor={modalTextColor}>
        <ModalHeader mt={6}>{select_language}</ModalHeader>
        <ModalCloseButton mt={2} />
        <ModalBody>
          <RadioGroup onChange={setDefaultLocale} value={defaultLocale}>
            <Stack>
              <Box
                borderRadius={'lg'}
                p={4}
                borderColor={'brand'}
                bgColor={defaultLocale == 'de-DE' ? radioBg : 'none'}
                borderWidth={defaultLocale == 'de-DE' ? 'medium' : 'thin'}
              >
                <Radio value="de-DE" size="lg" name="de-DE" w={'full'} h={'full'} variant={'brand'}>
                  🇩🇪 Deutsch
                </Radio>
              </Box>
              <Box
                borderRadius={'lg'}
                p={4}
                borderColor={'brand'}
                bgColor={defaultLocale == 'en-US' ? radioBg : 'none'}
                borderWidth={defaultLocale == 'en-US' ? 'medium' : 'thin'}
              >
                <Radio value="en-US" size="lg" name="en-US" w={'full'} h={'full'} variant={'brand'}>
                  🇬🇧 English
                </Radio>
              </Box>
              <Box
                borderRadius={'lg'}
                p={4}
                borderColor={'brand'}
                bgColor={defaultLocale == 'fr-FR' ? radioBg : 'none'}
                borderWidth={defaultLocale == 'fr-FR' ? 'medium' : 'thin'}
              >
                <Radio value="fr-FR" size="lg" name="fr-FR" w={'full'} h={'full'} variant={'brand'}>
                  🇫🇷 Français
                </Radio>
              </Box>
            </Stack>
          </RadioGroup>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              const newPath = catalogLanguagePath(window.location.pathname, locale, defaultLocale, catalogLocales);
              onClose();
              window.location.href = newPath;
            }}
          >
            {confirm}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
